<div class="body-restablecer"
  [class.vista-movil]="esResolucionMovil"
>
  <h1>¿Olvidaste tu contraseña?</h1>

  <div class="form">
    <div class="form-restablecer">
      <div class="form-restablecer-top">
        <div class="encabezado-formulario">
          <span class="titulo-formulario">Vas a restablecer tu contraseña de acceso a Unifersa.net:</span>
          <span class="descripcion-formulario">
            Introduce el correo electrónico asociado a tu cuenta y te haremos llegar un enlace para poder restablecer tu contraseña.
          </span>
        </div>

        <form [formGroup]="restablecerContrasenaForm" class="restablecer-form">
          <div class="inputs">
            <!-- <div class="usuario">
              <dx-text-box
                label="Usuario"
                [stylingMode]="stylingMode"
                [labelMode]="labelMode"
                formControlName="usuario"
                [validationStatus]="
                  getValidacionEstado('usuario', restablecerContrasenaForm)
                "
                [validationError]="
                  restablecerContrasenaForm.get('usuario')?.errors ?? {}
                    | validationErrorMessage
                "
                [elementAttr]="{ tabindex: '0' }"
                (keydown)="focusService.onKeyDown($event)"
              ></dx-text-box>
            </div> -->

            <div class="nombre">
              <!-- <p class="titulo">Email</p> -->
              <dx-text-box
                label="Correo electrónico"
                [stylingMode]="stylingMode"
                [labelMode]="labelMode"
                formControlName="correo"
                [elementAttr]="{ tabindex: '1' }"
                [validationStatus]="
                  getValidacionEstado('correo', restablecerContrasenaForm)
                "
                [validationError]="
                  restablecerContrasenaForm.get('correo')?.errors ?? {}
                    | validationErrorMessage
                "
                (keydown)="focusService.onKeyDown($event)"
              ></dx-text-box>
            </div>
          </div>

          <div class="form-restablecer-botonera">
            <button hidden="true"></button>
            
            <button class="enviar" 
              [disabled]="enviando"
              (click)="onSubmit()"
            > 
              Restablecer
            </button>

            <button class="btn-volver-atras" (click)="onVolverAtras()">
              Volver
            </button>   
          </div>      
        </form>
      </div>
    </div>
  </div>
</div>
